module.exports = __webpack_public_path__ + "images/category_lp/retro_game/main-view_ff41c80878bc42f9735d10974eba40b5.png";